<script>
import 'bulma/css/bulma.css'
export let title;
export let desc;
var isActive = false;
var theProblem = false;
var theProducts = false;
function changeActive(event) {
		isActive = !isActive
	}
function changeTheProblem(event) {
	theProblem = !theProblem
}

function changeTheProducts(event) {
	theProducts = !theProducts
}
</script>

<style>

.show {
	display: block;
	font-size: 0.875rem;
  	padding-bottom: 0.5rem;
	  padding-top: 0.5rem;
	  background-color: white;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid #dbdbdb;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    font-size: 0.875rem;
    left: 0;
    min-width: 100%;
    position: absolute;
    top: 100%;
    z-index: 20;
}

.show .navbar-item {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.navbar-brand img {
	height: 3em;
	max-height: none;
}

@media(max-width:768px) {
	.navbar-brand img {
		height: 2em;
	}

}

.has-dropdown, .contact {
	font-size: 1.75em;
}

hr {
	margin: 0 0 1.5rem 0;
}

.navbar-link:not(.is-arrowless)::after {
    border-color: darkblue;
}

.navbar-link:hover {
	color: darkblue;
}

</style>

<svelte:head>
{#if desc!=null}
<meta name="description" content="{desc}">
{:else}
<meta name="description" content="Accurate Pest Control Technology by Non-Toxic Methods. Non toxic mosquito control through the use of Larvex monolayers">
{/if}
<meta name="author" content="Charlie M-S">
<meta name="keywords" content="non toxic pest control larvex larvex larvex larvex larvex larvex accotec mosquito monolayer non toxic mosquito control non toxic mosquito control non toxic mosquito control larvex accotec larvex accotec larvex accotec larvex accotec larvex accotec larvex accotec larvex accotec">
{#if title!=null}
<title>{title + ' - Accotec'}</title>
{:else}
<title>Accotec Limited - Non toxic mosquito control through the use of Larvex monolayers</title>
{/if}
</svelte:head>

<nav class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <img src="img/logo.png" alt="Accotec">
    </a>

    <a role="button" class="navbar-burger burger" on:click="{changeActive}" class:is-active="{isActive}" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>
	<div class="navbar-menu" class:is-active="{isActive}">
	<div class="navbar-end">
      <div class="navbar-item has-dropdown is-hoverable" on:click="{changeTheProblem}">
        <a class="navbar-link">
          The Problem
        </a>

        <div class:navbar-dropdown="{!theProblem}" class:show="{theProblem}">
          <a class="navbar-item" href="/the-problem/mosquito">
            The Mosquito
          </a>
          <a class="navbar-item" href="/the-problem/lifecycle">
            The Lifecycle
          </a>
        </div>
      </div>


	  <div class="navbar-item has-dropdown is-hoverable" on:click="{changeTheProducts}">
        <a class="navbar-link">
          Larvex Products
        </a>

        <div class:navbar-dropdown="{!theProducts}" class:show="{theProducts}">
          <a class="navbar-item" href="/larvex">
            Larvex™
          </a>
          <a class="navbar-item" href="/larvex/100">
            Larvex 100™
          </a>
		  <hr class="navbar-divider">
          <a class="navbar-item" href="/larvex/physical-action">
            Physical Action
          </a>
		  <a class="navbar-item" href="/larvex/field-trials">
            Field Trials
          </a>
        </div>
      </div>

       <a class="navbar-item contact" href="mailto:info@accotec.com">
        Get In Touch
    	</a>
      </div>
	</div>
    
</nav>
<hr>
